import React, { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
import { Link as RouterLink } from 'react-router';
import A11y from 'chameleon/ui-stack/utilities/a11y';

const Link = ({ to, className, children }) => {
  const [toLink, setToLink] = useState(to);

  useEffect(() => {
    debounce(() => {
      setToLink(to);
    }, 1000);
  }, [to]);

  return (
    <A11y>
      <RouterLink className={className} to={toLink}>
        {children}
      </RouterLink>
    </A11y>
  );
};

export default Link;
